/** Mirrors hrm EmploymentType / EmployeeStatus. */
export const EMPLOYMENT_TYPES = [
  { value: 'employee', label: 'Employee' },
  { value: 'contractor', label: 'Contractor' },
] as const;

export type EmploymentType = (typeof EMPLOYMENT_TYPES)[number]['value'];

export const EMPLOYEE_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'on_leave', label: 'On leave' },
  { value: 'terminated', label: 'Terminated' },
] as const;

export type EmployeeStatus = (typeof EMPLOYEE_STATUSES)[number]['value'];

export const employmentTypeLabel = (s: string): string =>
  EMPLOYMENT_TYPES.find((x) => x.value === s)?.label ?? s;

export const employeeStatusLabel = (s: string): string =>
  EMPLOYEE_STATUSES.find((x) => x.value === s)?.label ?? s;

export function employeeStatusVariant(
  s: string,
): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (s === 'active') return 'default';
  if (s === 'on_leave') return 'secondary';
  if (s === 'terminated') return 'destructive';
  return 'outline';
}
